import { motion } from 'framer-motion';

type GreenLightLogoProps = {
  width?: number | string;
  height?: number | string;
  className?: string;
  animate?: boolean;
};

export const GreenLightLogo = ({
  width = 300,
  height = 'auto',
  className = '',
  animate = true,
}: GreenLightLogoProps) => {
  const containerVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, staggerChildren: 0.12 },
    },
  };

  const lineVariants = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: {
      pathLength: 1,
      opacity: 1,
      transition: { duration: 0.7, ease: 'easeOut' as const },
    },
  };

  return (
    <motion.div
      className={`inline-flex items-center ${className}`}
      initial={animate ? 'hidden' : 'visible'}
      animate="visible"
      variants={containerVariants}
    >
      <svg
        width={width}
        height={height}
        viewBox="0 0 680 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="max-w-full h-auto"
      >
        {/* Lime green background square */}
        <rect x="0" y="0" width="100" height="100" fill="#D4FF33" rx="16" />

        {/* Three diagonal energy ray lines */}
        <motion.line x1="20" y1="80" x2="55" y2="20" stroke="#111827" strokeWidth="9" strokeLinecap="round" variants={lineVariants} />
        <motion.line x1="40" y1="80" x2="75" y2="20" stroke="#111827" strokeWidth="9" strokeLinecap="round" variants={lineVariants} />
        <motion.line x1="60" y1="80" x2="95" y2="20" stroke="#111827" strokeWidth="9" strokeLinecap="round" variants={lineVariants} />

        {/* GreenLight wordmark */}
        <text
          x="136"
          y="76"
          fill="#111827"
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: '72px',
            letterSpacing: '-0.05em',
          }}
        >
          <tspan style={{ fontWeight: 600 }}>Green</tspan>
          <tspan style={{ fontWeight: 300 }}>Light</tspan>
        </text>
      </svg>
    </motion.div>
  );
};
